import { RowEditAndDelete } from 'components/icons/RowEditAndDelete';

export const tableColumnsManagement = [
	{
		Header: 'Usuário',
		accessor: 'usuario',
	},
	{
		Header: 'Login',
		accessor: 'login',
	},
	{
		Header: 'Tipo',
		accessor: 'tipo',
	},
	{
		Header: 'Notificações Robô',
		accessor: 'is_bot_notification',
		filter: false,
		type: 'switch-actionable',
	},
	{
		Header: 'Status',
		accessor: 'status',
	},
	{
		Header: ' ',
		type: 'jsx',
		accessor: 'button',
		jsx: RowEditAndDelete,
		filter: false,
	},
];
